const e = "Aparthotels", s = "Apartments", t = "Business", o = "Campsites", n = "Couple", i = "Family", r = "Friends", l = "Hostels", a = "Hotels", u = "Resorts", m = "Restaurants", p = {
  "{num} reviews": "{num} reviews",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} in {location}",
  "All languages": "All languages",
  "All traveler types": "All traveler types",
  Aparthotels: e,
  Apartments: s,
  "B&Bs": "B&Bs",
  "based on {number} reviews": "based on {number} reviews",
  Business: t,
  Campsites: o,
  Couple: n,
  Family: i,
  Friend: r,
  "Highlighted reviews": "Highlighted Reviews",
  Hostels: l,
  Hotels: a,
  "No reviews found": "No reviews found",
  "Pet-friendly": "Pet-friendly",
  "Posted on {reviewer}": "Posted on {reviewer}",
  "Read Reviews": "Read Reviews",
  Resorts: u,
  Restaurants: m,
  "Review Summary": "Review Summary",
  "Reviews by Source": "Reviews by Source"
};
export {
  e as Aparthotels,
  s as Apartments,
  t as Business,
  o as Campsites,
  n as Couple,
  i as Family,
  r as Friend,
  l as Hostels,
  a as Hotels,
  u as Resorts,
  m as Restaurants,
  p as default
};
//# sourceMappingURL=en.DCsRMqGN.js.map
